var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJinriyuyue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05_\u4ECA\u65E5\u9884\u7EA6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.07,11.86V55.75h-40V11.86h40m0-4h-40a4,4,0,0,0-4,4V55.75a4,4,0,0,0,4,4h40a4,4,0,0,0,4-4V11.86a4,4,0,0,0-4-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4a2,2,0,0,0-2,2v7.77a2,2,0,1,0,4,0V6a2,2,0,0,0-2-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42,4a2,2,0,0,0-2,2v7.77a2,2,0,0,0,4,0V6a2,2,0,0,0-2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.24,24.07H11.75a2,2,0,0,0-2,2h0a2,2,0,0,0,2,2H53.24a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22,35.9H18a2,2,0,1,0,0,4h4a2,2,0,0,0,0-4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34,35.9H30a2,2,0,0,0,0,4h4a2,2,0,0,0,0-4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46,35.9H42a2,2,0,0,0,0,4h4a2,2,0,0,0,0-4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.07,43.81h-4a2,2,0,0,0,0,4h4a2,2,0,0,0,0-4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.13,43.81h-4a2,2,0,1,0,0,4h4a2,2,0,0,0,0-4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12,43.81h-4a2,2,0,0,0,0,4h4a2,2,0,1,0,0-4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJinriyuyue);
export default __webpack_public_path__ + "static/media/jinriyuyue.d6111318.svg";
export { ForwardRef as ReactComponent };